
import React, { createContext, useContext, useEffect, useState } from "react"
import { BACKEND_URL } from "../constants"

const ArticlesContext = createContext(null)

export const useArticles = () => useContext(ArticlesContext)

export const ArticlesProvider = ({ children }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`${BACKEND_URL}/articlesTest`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Błąd pobierania danych")
        }
        return res.json()
      })
      .then((result) => {
        setData(result)
      })
      .catch((err) => {
        console.error("Błąd ładowania danych:", err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <ArticlesContext.Provider value={{ data, loading }}>
      {children}
    </ArticlesContext.Provider>
  )
}
